import config from "../../config";

const partialCancelBooking = async (
  hotelId,
  bookingId,
  rooms,
  setPartialCancelLoader,
  setPartialCancelResult
) => {
  let token = sessionStorage.getItem("token");

  try {
    let response = await fetch(
      config.beAlphaEndpoint + "partial-cancel-booking",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          hotel_id: hotelId,
          booking_id: bookingId,
          rooms: rooms,
        }),
      }
    );

    let responseJson = await response.json();

    setPartialCancelResult({
      status: responseJson.status,
      message:
        responseJson.status === 1
          ? "Selected rooms cancelled successfully"
          : responseJson.message || "Cancellation failed",
    });

    setPartialCancelLoader(false);
  } catch (error) {
    setPartialCancelResult({
      status: 0,
      message: "Something went wrong",
    });
    setPartialCancelLoader(false);
  }
};

export default partialCancelBooking;
